var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useMemo, useState } from 'react';
import { PermissionsCheck } from '../../Components/Auth/PermissionsCheck';
import { Button, ButtonMode } from '../../Components/Button';
import { DurationPicker } from '../../Components/DurationPicker/DurationPicker';
import { FloatingLinearProgress } from '../../Components/FloatingLinearProgress';
import { CheckIcon, CloseIcon, EditIcon, TrashCanIcon } from '../../Components/Icons';
import { MaskedTextField } from '../../Components/MaskedTextField';
import { SearchInput } from '../../Components/SearchInput';
import { TimeUnits } from '../../Config/MedicationConfig';
import { MedicationListStatus } from '../../Contracts/MedicationListsSearchFilter.Request';
import { MedicationsPermissions } from '../../MedicationsPermissions';
import { numberGreaterThanZeroInputFilter } from '../../Shared/InputFilters';
import { iconLight, primary } from '../../Styles/Colours';
import styles from './MedicationListEntries.module.css';
import { MedicationListErrors } from './MedicationListErrors';
import { EntryLoadingState } from './UseMedicationListState';
import { Tooltip } from '@material-ui/core';
function createBaseStateFromProps(it) {
    return {
        defaultPackAmount: it.defaultPackAmount ? it.defaultPackAmount.toString() : '',
        defaultDosageInstructions: it.defaultDosageInstructions ? it.defaultDosageInstructions : '',
        defaultDuration: it.defaultDuration
            ? {
                number: it.defaultDuration.number.toString(),
                timeUnits: it.defaultDuration.timeUnits
            }
            : {
                number: '',
                timeUnits: TimeUnits.Days
            }
    };
}
var truncateAndTooltip = function (text) {
    return (React.createElement("div", { className: styles.truncate },
        React.createElement(Tooltip, { title: text, placement: 'bottom-start' },
            React.createElement("span", null, text))));
};
function DisplayRow(props) {
    var _a, _b;
    return (React.createElement("div", { className: styles.row, "data-test-id": 'display-row', "data-test-name": (_b = (_a = props.it.medication) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.slice(0, 20) },
        truncateAndTooltip(props.it.medication.name),
        React.createElement("div", null, props.it.defaultPackAmount),
        React.createElement("div", null, props.it.defaultDuration &&
            props.it.defaultDuration.number &&
            Number(props.it.defaultDuration.number) > 0
            ? props.it.defaultDuration.number + " " + props.it.defaultDuration.timeUnits
            : ''),
        truncateAndTooltip(props.it.defaultDosageInstructions),
        !props.medListState.editRowId &&
            props.medListState.medicationList &&
            props.medListState.medicationList.status === MedicationListStatus.Draft && (React.createElement("div", { className: styles.buttonContainer },
            React.createElement(PermissionsCheck, { permission: MedicationsPermissions.WriteMedicationLists },
                React.createElement(Button, { mode: ButtonMode.text, noShadowOnHover: true, iconOnly: true, tooltip: 'Edit', testId: 'medication-list-item-edit', onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        props.onEditClick(props.it);
                    } },
                    React.createElement(EditIcon, { color: iconLight, size: '20', noPadding: true })),
                React.createElement(Button, { mode: ButtonMode.text, noShadowOnHover: true, iconOnly: true, tooltip: 'Delete', testId: 'medication-list-item-delete', onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        props.onDeleteClick(props.it);
                    } },
                    React.createElement(TrashCanIcon, { color: iconLight, size: '20', noPadding: true })))))));
}
function EditRow(props) {
    var _a, _b, _c, _d, _e;
    var _f = __read(useState(createBaseStateFromProps(props.it)), 2), rowData = _f[0], setRowData = _f[1];
    var handleSaveClick = function () {
        var newData = __assign(__assign({}, props.it), { defaultDuration: rowData.defaultDuration.number
                ? {
                    number: Number(rowData.defaultDuration.number),
                    timeUnits: rowData.defaultDuration.timeUnits
                }
                : null, defaultDosageInstructions: rowData.defaultDosageInstructions, defaultPackAmount: rowData.defaultPackAmount ? Number(rowData.defaultPackAmount) : undefined });
        props.onSaveMedication(newData);
    };
    return (React.createElement("div", { className: styles.row, "data-test-id": 'edit-row', "data-test-name": (_b = (_a = props.it.medication) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.slice(0, 20) },
        React.createElement("div", null, (_c = props.it.medication) === null || _c === void 0 ? void 0 : _c.name),
        React.createElement("div", null,
            React.createElement(MaskedTextField, { value: (_d = rowData.defaultPackAmount) !== null && _d !== void 0 ? _d : '', testId: 'pack-size', disabled: props.medListState.updatingRow, onChange: function (value) {
                    setRowData(function (data) { return (__assign(__assign({}, data), { defaultPackAmount: value })); });
                }, onClear: function () {
                    setRowData(function (data) { return (__assign(__assign({}, data), { defaultPackAmount: '' })); });
                }, hideWarningEmptyHelperText: true, filterFunction: numberGreaterThanZeroInputFilter })),
        React.createElement("div", null,
            React.createElement(DurationPicker, { timeLength: rowData.defaultDuration, onUpdateTimeLength: function (timeLength) {
                    setRowData(function (data) { return (__assign(__assign({}, data), { defaultDuration: timeLength })); });
                }, disabled: props.medListState.updatingRow, inputHeight: 34, hideLabel: true, hideWarningEmptyHelperText: true, testId: 'course-duration' })),
        React.createElement("div", null,
            React.createElement(MaskedTextField, { value: (_e = rowData.defaultDosageInstructions) !== null && _e !== void 0 ? _e : '', testId: 'dosage-instruction', disabled: props.medListState.updatingRow, onChange: function (value) {
                    setRowData(function (data) { return (__assign(__assign({}, data), { defaultDosageInstructions: value })); });
                }, onClear: function () {
                    setRowData(function (data) { return (__assign(__assign({}, data), { defaultDosageInstructions: '' })); });
                }, hideWarningEmptyHelperText: true })),
        !props.medListState.updatingRow && (React.createElement("div", { className: styles.buttonContainer },
            React.createElement(Button, { mode: ButtonMode.text, noShadowOnHover: true, iconOnly: true, tooltip: 'Save', testId: 'medication-list-item-save', onClick: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleSaveClick();
                } },
                React.createElement(CheckIcon, { color: primary, size: '20', noPadding: true })),
            React.createElement(PermissionsCheck, { permission: MedicationsPermissions.WriteMedicationLists },
                React.createElement(Button, { mode: ButtonMode.text, noShadowOnHover: true, iconOnly: true, tooltip: 'Cancel', testId: 'medication-list-item-cancel', onClick: function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        props.onCancel();
                    } },
                    React.createElement(CloseIcon, { color: iconLight, size: '20', noPadding: true })))))));
}
export var MedicationListEntries = function (props) {
    var _a, _b;
    var entries = useMemo(function () {
        return props.medListState.entries.map(function (it) {
            return props.medListState.editRowId === it.id ? (React.createElement(EditRow, { medListState: props.medListState, key: it.id, it: it, onSaveMedication: props.onSaveMedication, onCancel: props.onRowEditCancelled })) : (React.createElement(DisplayRow, { medListState: props.medListState, key: it.id, it: it, onEditClick: props.onRowEditStart, onDeleteClick: props.onDeleteMedication }));
        });
    }, [
        props.medListState.editRowId,
        props.medListState.entries,
        (_a = props.medListState.medicationList) === null || _a === void 0 ? void 0 : _a.status,
        props.medListState.updatingRow
    ]);
    var hideSearchBar = !props.medListState.queryUsed && props.medListState.entries.length === 0;
    return (React.createElement("div", { className: styles.table },
        React.createElement(FloatingLinearProgress, { display: props.medListState.entryLoadingState === EntryLoadingState.Refreshing }),
        React.createElement("div", { className: styles.tableHeader },
            React.createElement("div", null, "Medication name"),
            React.createElement("div", null, "No. of packs"),
            React.createElement("div", null, "Course duration"),
            React.createElement("div", null, "Dosage instruction")),
        !hideSearchBar && (React.createElement("div", { className: styles.search },
            React.createElement(SearchInput, { testId: 'entry-list-search', value: props.medListState.query, fullWidth: true, onChange: function (e) {
                    props.onSearch(e.target.value);
                }, onClear: function () {
                    props.onSearch('');
                }, placeholder: 'Search by medication name...' }))),
        entries,
        React.createElement(MedicationListErrors, { hasEntries: props.medListState.entries.length > 0, hasQuery: !!props.medListState.queryUsed, hasPublished: ((_b = props.medListState.medicationList) === null || _b === void 0 ? void 0 : _b.status) == MedicationListStatus.Published, onAddAction: props.onAddAction })));
};
